import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Col, Row, FormGroup, Label, Form } from 'reactstrap';
import { Icon } from './Icon';
import upload from '../icons/upload-1.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileList from './FileList';
import CustomLoader from './CustomLoader';
import Select from 'react-select';
import { customSelectStyles } from '../scripts/selectStyle';


const displayProducts = [
	{ label: 'Каталог', value: 0 },
	{ label: 'Наши работы', value: 1 }
];

const productTypes = [
	{ label: 'Современная', value: 0 },
	{ label: 'Классика', value: 1 },
	{ label: 'Неоклассика', value: 2 }
];

export class UploadItemClass extends Component {
	constructor(props) {
		super(props);

		this.state = {
			title: '',
			description: '',
			typeProduct: null,
			displayProduct: null,
			files: [],
			filesForDetete: [],
			isCreatePage: true,
			loader: !!this.props.match.params.id
		};

		this.handleSubmitAdd = this.handleSubmitAdd.bind(this);
		this.handleSubmitUpdate = this.handleSubmitUpdate.bind(this);
		this.handleDeleteFile = this.handleDeleteFile.bind(this);
		this.handleSetMainImage = this.handleSetMainImage.bind(this);
	}

	componentDidMount() {
		if (this.props.match.params.id) {
			this.loadProductData(this.props.match.params.id);
		}
	}

	async loadProductData(productId) {
		try {
			const data = new FormData();
			data.append('id', productId);

			const response = await fetch(`api/DataforDB/GetProduct`, {
				method: 'POST',
				body: data
			});

			if (!response.ok) throw new Error(response.statusText);

			const product = await response.json();

			this.setState({
				loader: false,
				title: product.name ?? '',
				description: product.description ?? '',
				displayProduct: displayProducts.find(x => x.value === product.displayStatus),
				typeProduct: productTypes.find(x => x.value === product.typeProduct),
				files: product.images.map(img => ({
					path: img.path,
					id: img.id,
					productId: img.productId
				})),
				isCreatePage: false
			});
		} catch (error) {
			toast.error('Ошибка загрузки продукта');
		}
	}

	async handleSubmitAdd(e) {
		e.preventDefault();

		const { title, description, typeProduct, displayProduct, files } = this.state;

		if (!files.length) {
			toast.error('Необходимо загрузить хотя бы одно изображение');
			return;
		}

		const formData = new FormData();

		files.forEach(f => formData.append('files', f.file));

		formData.append('name', title?.trim() || '');
		formData.append('description', description?.trim() || '');
		formData.append('typeProduct', typeProduct.value);
		formData.append('displayProduct', displayProduct.value);

		console.log(formData);
		debugger;

		try {
			const response = await fetch('api/DataforDB/AddProduct', {
				method: 'POST',
				body: formData
			});

			if (!response.ok) throw new Error(response.statusText);

			const id = await response.json();

			toast.success('Товар успешно добавлен');
			this.props.history.push(`/product/${id}/${this.props.match.params.type}`);
		} catch (error) {
			toast.error('Ошибка добавления товара');
		}
	}

	async handleSubmitUpdate(e) {
		e.preventDefault();

		const { title, description, typeProduct, displayProduct, files, filesForDetete } = this.state;

		if (!files.length) {
			toast.error('Необходимо загрузить хотя бы одно изображение');
			return;
		}

		const formData = new FormData();

		files.forEach(f => {
			if (f.file) formData.append('newFiles', f.file);
		});

		filesForDetete.forEach(id => formData.append('filesForDetete', id));

		formData.append('id', this.props.match.params.id);
		formData.append('name', title);
		formData.append('description', description);
		formData.append('typeProduct', typeProduct.value);
		formData.append('displayProduct', displayProduct.value);

		try {
			const response = await fetch('api/DataforDB/UpdateProduct', {
				method: 'POST',
				body: formData
			});

			if (!response.ok) throw new Error(response.statusText);

			toast.success('Товар обновлен');
			this.props.history.push(`/product/${this.props.match.params.id}`);
		} catch (error) {
			toast.error('Ошибка обновления товара');
		}
	}

	handleDeleteFile(file) {
		this.setState(prev => ({
			files: prev.files.filter(f => (file.id ? f.id !== file.id : f !== file)),
			filesForDetete: file.id
				? [...prev.filesForDetete, file.id]
				: prev.filesForDetete
		}));
	}

	handleSetMainImage(fileId) {
		const formData = new FormData();
		formData.append('productId', this.props.match.params.id);
		formData.append('imageId', fileId);

		fetch('api/DataforDB/SetMainImage', {
			method: 'POST',
			body: formData
		})
			.then(r => {
				if (!r.ok) throw new Error();

				this.setState(prev => ({
					files: prev.files.map(f => ({
						...f,
						isMain: f.id === fileId
					}))
				}));
			})
			.catch(() => toast.error('Ошибка установки главного изображения'));
	}

	render() {
		const { title, description, typeProduct, displayProduct, files, loader } = this.state;

		const SubmitHandler = this.props.match.params.id
			? this.handleSubmitUpdate
			: this.handleSubmitAdd;

		return (
			<>
				<CustomLoader visible={loader} />

				<div className={loader ? 'display-none' : ''}>
					<ToastContainer />

					<h1>Загрузка товара</h1>

					<Form onSubmit={SubmitHandler}>
						<FormGroup>
							<Label>Заголовок</Label>
							<input
								className="form-control"
								value={title}
								onChange={e => this.setState({ title: e.target.value })}
							/>
						</FormGroup>

						<FormGroup>
							<Label>Описание</Label>
							<textarea
								className="form-control"
								value={description}
								onChange={e => this.setState({ description: e.target.value })}
							/>
						</FormGroup>

						<FormGroup>
							<Label>Список</Label>
							<Select
								value={displayProduct}
								options={displayProducts}
								onChange={value => this.setState({ displayProduct: value })}
								styles={customSelectStyles}
							/>
						</FormGroup>

						<FormGroup>
							<Label>Тип</Label>
							<Select
								value={typeProduct}
								options={productTypes}
								onChange={value => this.setState({ typeProduct: value })}
								styles={customSelectStyles}
							/>
						</FormGroup>

						<FormGroup>
							<Label>Файлы</Label>

							<Row>
								<Col xs="auto">
									<Dropzone
										onDrop={accepted =>
											this.setState(prev => ({
												files: [
													...prev.files,
													...accepted.map(file => ({ file }))
												]
											}))
										}
									>
										{({ getRootProps, getInputProps }) => (
											<div className="drop-zone" {...getRootProps()}>
												<input {...getInputProps()} />
												<Icon name={upload} />
											</div>
										)}
									</Dropzone>
								</Col>

								<Col>
									<FileList
										files={files}
										onDelete={this.handleDeleteFile}
										onSetMain={this.handleSetMainImage}
									/>
								</Col>
							</Row>
						</FormGroup>

						<FormGroup>
							<button type="submit" className="btn btn-primary">
								{this.props.match.params.id ? 'Обновить' : 'Добавить'}
							</button>
						</FormGroup>
					</Form>
				</div>
			</>
		);
	}
}